"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reloadDataCacheFunc = exports.GridDisplay = void 0;
const lodash_1 = __importDefault(require("lodash"));
const GridConfig_1 = require("./GridConfig");
const dbgate_filterparser_1 = require("dbgate-filterparser");
const dbgate_tools_1 = require("dbgate-tools");
const dbgate_sqltree_1 = require("dbgate-sqltree");
const dbgate_tools_2 = require("dbgate-tools");
class GridDisplay {
    constructor(config, setConfig, cache, setCache, driver, dbinfo = null, serverVersion = null) {
        this.config = config;
        this.setConfig = setConfig;
        this.cache = cache;
        this.setCache = setCache;
        this.driver = driver;
        this.dbinfo = dbinfo;
        this.serverVersion = serverVersion;
        this.formColumns = [];
        this.changeSetKeyFields = null;
        this.editableStructure = null;
        this.sortable = false;
        this.groupable = false;
        this.filterable = false;
        this.editable = false;
        this.isLoadedCorrectly = true;
        this.supportsReload = false;
        this.isDynamicStructure = false;
        this.filterBehaviourOverride = null;
        this.dialect = ((driver === null || driver === void 0 ? void 0 : driver.dialectByVersion) && (driver === null || driver === void 0 ? void 0 : driver.dialectByVersion(serverVersion))) || (driver === null || driver === void 0 ? void 0 : driver.dialect);
    }
    get baseTableOrSimilar() {
        return this.baseTable || this.baseCollection || this.baseView;
    }
    get baseTableOrCollection() {
        return this.baseTable || this.baseCollection;
    }
    get baseTableOrView() {
        return this.baseTable || this.baseView;
    }
    setColumnVisibility(uniquePath, isVisible) {
        const uniqueName = uniquePath.join('.');
        if (uniquePath.length == 1) {
            this.includeInColumnSet([
                { field: 'hiddenColumns', uniqueName, isIncluded: !isVisible },
                isVisible == false && this.isDynamicStructure && { field: 'addedColumns', uniqueName, isIncluded: false },
            ]);
        }
        else {
            this.includeInColumnSet([{ field: 'addedColumns', uniqueName, isIncluded: isVisible }]);
            if (!this.isDynamicStructure)
                this.reload();
        }
    }
    addDynamicColumn(name) {
        this.includeInColumnSet([
            { field: 'addedColumns', uniqueName: name, isIncluded: true },
            { field: 'hiddenColumns', uniqueName: name, isIncluded: false },
        ]);
    }
    focusColumns(uniqueNames) {
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { focusedColumns: uniqueNames })));
    }
    get hasReferences() {
        return false;
    }
    get focusedColumns() {
        return this.config.focusedColumns;
    }
    get engine() {
        var _a;
        return (_a = this.driver) === null || _a === void 0 ? void 0 : _a.engine;
    }
    get allColumns() {
        return this.getColumns(null).filter(col => col.isChecked || col.uniquePath.length == 1);
    }
    findColumn(uniqueName) {
        return this.getColumns(null).find(x => x.uniqueName == uniqueName);
    }
    getFkTarget(column) {
        return null;
    }
    reload() {
        this.setCache(reloadDataCacheFunc);
    }
    includeInColumnSet(modifications) {
        this.setConfig(cfg => {
            let res = cfg;
            for (const modification of modifications) {
                if (!modification) {
                    continue;
                }
                const { field, uniqueName, isIncluded } = modification;
                if (isIncluded) {
                    res = Object.assign(Object.assign({}, res), { [field]: [...(cfg[field] || []), uniqueName] });
                }
                else {
                    res = Object.assign(Object.assign({}, res), { [field]: (cfg[field] || []).filter(x => x != uniqueName) });
                }
            }
            return res;
        });
    }
    showAllColumns() {
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { hiddenColumns: [] })));
    }
    hideAllColumns() {
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { hiddenColumns: this.columns.filter(x => x.uniquePath.length == 1).map(x => x.uniqueName) })));
    }
    get hiddenColumnIndexes() {
        // console.log('GridDisplay.hiddenColumn', this.config.hiddenColumns);
        return (this.config.hiddenColumns || []).map(x => lodash_1.default.findIndex(this.allColumns, y => y.uniqueName == x));
    }
    isColumnChecked(column) {
        // console.log('isColumnChecked', column, this.config.hiddenColumns);
        return column.uniquePath.length == 1
            ? !this.config.hiddenColumns.includes(column.uniqueName)
            : this.config.addedColumns.includes(column.uniqueName);
    }
    applyFilterOnSelect(select, displayedColumnInfo) {
        var _a, _b;
        const conditions = [];
        for (const uniqueName in this.config.filters) {
            const filter = this.config.filters[uniqueName];
            if (!filter)
                continue;
            const column = displayedColumnInfo[uniqueName];
            if (!column)
                continue;
            try {
                const condition = (0, dbgate_filterparser_1.parseFilter)(filter, (_b = (_a = this.driver) === null || _a === void 0 ? void 0 : _a.getFilterBehaviour(column.dataType, dbgate_tools_2.standardFilterBehaviours)) !== null && _b !== void 0 ? _b : (0, dbgate_tools_2.detectSqlFilterBehaviour)(column.dataType));
                if (condition) {
                    conditions.push(lodash_1.default.cloneDeepWith(condition, (expr) => {
                        if (expr.exprType == 'placeholder') {
                            return this.createColumnExpression(column, { alias: column.sourceAlias });
                        }
                        // return {
                        //   exprType: 'column',
                        //   columnName: column.columnName,
                        //   source: { alias: column.sourceAlias },
                        // };
                    }));
                }
            }
            catch (err) {
                console.warn(err.message);
                continue;
            }
        }
        if (this.baseTableOrView && this.config.multiColumnFilter) {
            const orCondition = {
                conditionType: 'or',
                conditions: [],
            };
            for (const column of this.baseTableOrView.columns) {
                try {
                    const condition = (0, dbgate_filterparser_1.parseFilter)(this.config.multiColumnFilter, (0, dbgate_tools_2.detectSqlFilterBehaviour)(column.dataType));
                    if (condition) {
                        orCondition.conditions.push(lodash_1.default.cloneDeepWith(condition, (expr) => {
                            if (expr.exprType == 'placeholder') {
                                return this.createColumnExpression(column, { alias: 'basetbl' });
                            }
                        }));
                    }
                }
                catch (err) {
                    // skip for this column
                    continue;
                }
            }
            if (orCondition.conditions.length > 0) {
                conditions.push(orCondition);
            }
        }
        if (conditions.length > 0) {
            select.where = {
                conditionType: 'and',
                conditions,
            };
        }
    }
    applySortOnSelect(select, displayedColumnInfo) {
        var _a;
        if (((_a = this.config.sort) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            select.orderBy = this.config.sort
                .map(col => (Object.assign(Object.assign({}, col), { dispInfo: displayedColumnInfo[col.uniqueName] })))
                .map(col => (Object.assign(Object.assign({}, col), { expr: select.columns.find(x => x.alias == col.uniqueName) })))
                .filter(col => col.dispInfo && col.expr)
                .map(col => (Object.assign(Object.assign({}, col.expr), { direction: col.order })));
        }
    }
    get isGrouped() {
        return !lodash_1.default.isEmpty(this.config.grouping);
    }
    get groupColumns() {
        return this.isGrouped ? lodash_1.default.keys(lodash_1.default.pickBy(this.config.grouping, v => v == 'GROUP' || v.startsWith('GROUP:'))) : null;
    }
    applyGroupOnSelect(select, displayedColumnInfo) {
        const groupColumns = this.groupColumns;
        if (groupColumns && groupColumns.length > 0) {
            // @ts-ignore
            select.groupBy = groupColumns.map(col => {
                const colExpr = {
                    exprType: 'column',
                    columnName: displayedColumnInfo[col].columnName,
                    source: { alias: displayedColumnInfo[col].sourceAlias },
                };
                const grouping = this.config.grouping[col];
                if (grouping.startsWith('GROUP:')) {
                    return {
                        exprType: 'transform',
                        transform: grouping,
                        expr: colExpr,
                    };
                }
                else {
                    return colExpr;
                }
            });
        }
        if (!lodash_1.default.isEmpty(this.config.grouping)) {
            for (let i = 0; i < select.columns.length; i++) {
                const uniqueName = select.columns[i].alias;
                // if (groupColumns && groupColumns.includes(uniqueName)) continue;
                const grouping = this.getGrouping(uniqueName);
                if (grouping == 'GROUP') {
                    continue;
                }
                else if (grouping == 'NULL') {
                    select.columns[i].alias = null;
                }
                else if (grouping && grouping.startsWith('GROUP:')) {
                    select.columns[i] = {
                        exprType: 'transform',
                        transform: grouping,
                        expr: select.columns[i],
                        alias: select.columns[i].alias,
                    };
                }
                else {
                    let func = 'MAX';
                    let argsPrefix = '';
                    if (grouping) {
                        if (grouping == 'COUNT DISTINCT') {
                            func = 'COUNT';
                            argsPrefix = 'DISTINCT ';
                        }
                        else {
                            func = grouping;
                        }
                    }
                    select.columns[i] = {
                        alias: select.columns[i].alias,
                        exprType: 'call',
                        func,
                        argsPrefix,
                        args: [select.columns[i]],
                    };
                }
            }
            select.columns = select.columns.filter(x => x.alias);
        }
    }
    getColumns(columnFilter) {
        return this.columns.filter(col => (0, dbgate_tools_1.filterName)(columnFilter, col.columnName));
    }
    getGridColumns() {
        return this.getColumns(null).filter(x => this.isColumnChecked(x));
    }
    isExpandedColumn(uniqueName) {
        return this.config.expandedColumns.includes(uniqueName);
    }
    toggleExpandedColumn(uniqueName, value) {
        this.includeInColumnSet([
            { field: 'expandedColumns', uniqueName, isIncluded: value == null ? !this.isExpandedColumn(uniqueName) : value },
        ]);
    }
    getFilter(uniqueName) {
        return this.config.filters[uniqueName];
    }
    setFilter(uniqueName, value) {
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { filters: Object.assign(Object.assign({}, cfg.filters), { [uniqueName]: value }), formViewRecordNumber: 0 })));
        this.reload();
    }
    setMutliColumnFilter(value) {
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { multiColumnFilter: value, formViewRecordNumber: 0 })));
        this.reload();
    }
    showFilter(uniqueName) {
        this.setConfig(cfg => {
            if (!cfg.filters.uniqueName)
                return Object.assign(Object.assign({}, cfg), { filters: Object.assign(Object.assign({}, lodash_1.default.omitBy(cfg.filters, v => !v)), { [uniqueName]: '' }) });
            return cfg;
        });
    }
    removeFilter(uniqueName) {
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { filters: lodash_1.default.omit(cfg.filters, [uniqueName]), formFilterColumns: (cfg.formFilterColumns || []).filter(x => x != uniqueName) })));
        this.reload();
    }
    setFilters(dct) {
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { filters: Object.assign(Object.assign({}, cfg.filters), dct) })));
        this.reload();
    }
    setSort(uniqueName, order) {
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { sort: [{ uniqueName, order }] })));
        this.reload();
    }
    addToSort(uniqueName, order) {
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { sort: [...(cfg.sort || []), { uniqueName, order }] })));
        this.reload();
    }
    clearSort() {
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { sort: [] })));
        this.reload();
    }
    setGrouping(uniqueName, groupFunc) {
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { grouping: groupFunc
                ? Object.assign(Object.assign({}, cfg.grouping), { [uniqueName]: groupFunc }) : lodash_1.default.omitBy(cfg.grouping, (v, k) => k == uniqueName) })));
        this.reload();
    }
    getGrouping(uniqueName) {
        var _a, _b;
        if (this.isGrouped) {
            if (this.config.grouping[uniqueName])
                return this.config.grouping[uniqueName];
            const column = (_b = (_a = (this.baseTable || this.baseView)) === null || _a === void 0 ? void 0 : _a.columns) === null || _b === void 0 ? void 0 : _b.find(x => x.columnName == uniqueName);
            if ((0, dbgate_tools_2.isTypeLogical)(column === null || column === void 0 ? void 0 : column.dataType))
                return 'COUNT DISTINCT';
            if (column === null || column === void 0 ? void 0 : column.autoIncrement)
                return 'COUNT';
            return 'MAX';
        }
        return null;
    }
    clearGrouping() {
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { grouping: {} })));
        this.reload();
    }
    getSortOrder(uniqueName) {
        var _a;
        return (_a = this.config.sort.find(x => x.uniqueName == uniqueName)) === null || _a === void 0 ? void 0 : _a.order;
    }
    getSortOrderIndex(uniqueName) {
        if (this.config.sort.length <= 1)
            return -1;
        return lodash_1.default.findIndex(this.config.sort, x => x.uniqueName == uniqueName);
    }
    isSortDefined() {
        return (this.config.sort || []).length > 0;
    }
    get filterCount() {
        return lodash_1.default.compact(lodash_1.default.values(this.config.filters)).length;
    }
    clearFilters() {
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { filters: {}, multiColumnFilter: null })));
        this.reload();
    }
    resetConfig() {
        this.setConfig(cfg => (0, GridConfig_1.createGridConfig)());
        this.reload();
    }
    getChangeSetCondition(row) {
        if (!this.changeSetKeyFields)
            return null;
        return lodash_1.default.pick(row, this.changeSetKeyFields);
    }
    getChangeSetField(row, uniqueName, insertedRowIndex, existingRowIndex = null, baseNameOmitable = false) {
        const col = this.columns.find(x => x.uniqueName == uniqueName);
        if (!col)
            return null;
        const baseObj = this.baseTableOrSimilar;
        if (!baseNameOmitable) {
            if (!baseObj)
                return null;
            if (baseObj.pureName != col.pureName || baseObj.schemaName != col.schemaName) {
                return null;
            }
        }
        return Object.assign(Object.assign({}, this.getChangeSetRow(row, insertedRowIndex, existingRowIndex, baseNameOmitable)), { uniqueName: uniqueName, columnName: col.columnName });
    }
    getChangeSetRow(row, insertedRowIndex, existingRowIndex, baseNameOmitable = false) {
        const baseObj = this.baseTableOrSimilar;
        if (!baseNameOmitable && !baseObj)
            return null;
        return {
            pureName: baseObj === null || baseObj === void 0 ? void 0 : baseObj.pureName,
            schemaName: baseObj === null || baseObj === void 0 ? void 0 : baseObj.schemaName,
            insertedRowIndex,
            existingRowIndex,
            condition: insertedRowIndex == null && existingRowIndex == null ? this.getChangeSetCondition(row) : null,
        };
    }
    createSelect(options = {}) {
        return null;
    }
    processReferences(select, displayedColumnInfo, options) { }
    createColumnExpression(col, source, alias) {
        let expr = null;
        if (this.dialect.createColumnViewExpression) {
            expr = this.dialect.createColumnViewExpression(col.columnName, col.dataType, source, alias);
            if (expr) {
                return expr;
            }
        }
        return Object.assign({ exprType: 'column', alias: alias || col.columnName, source }, col);
    }
    createSelectBase(name, columns, options, defaultOrderColumnName) {
        var _a, _b;
        if (!columns)
            return null;
        const orderColumnName = defaultOrderColumnName !== null && defaultOrderColumnName !== void 0 ? defaultOrderColumnName : (_a = columns[0]) === null || _a === void 0 ? void 0 : _a.columnName;
        const select = {
            commandType: 'select',
            from: {
                name: lodash_1.default.pick(name, ['schemaName', 'pureName']),
                alias: 'basetbl',
            },
            columns: columns.map(col => this.createColumnExpression(col, { alias: 'basetbl' })),
            orderBy: ((_b = this.driver) === null || _b === void 0 ? void 0 : _b.requiresDefaultSortCriteria)
                ? [
                    {
                        exprType: 'column',
                        columnName: orderColumnName,
                        direction: 'ASC',
                    },
                ]
                : null,
        };
        const displayedColumnInfo = lodash_1.default.keyBy(this.columns.map(col => (Object.assign(Object.assign({}, col), { sourceAlias: 'basetbl' }))), 'uniqueName');
        this.processReferences(select, displayedColumnInfo, options);
        this.applyFilterOnSelect(select, displayedColumnInfo);
        this.applyGroupOnSelect(select, displayedColumnInfo);
        this.applySortOnSelect(select, displayedColumnInfo);
        return select;
    }
    getRowNumberOverSelect(select, offset, count) {
        const innerSelect = {
            commandType: 'select',
            from: select.from,
            where: select.where,
            columns: [
                ...select.columns,
                {
                    alias: '_RowNumber',
                    exprType: 'rowNumber',
                    orderBy: select.orderBy
                        ? select.orderBy.map(x => x.exprType != 'column'
                            ? x
                            : x.source
                                ? x
                                : Object.assign(Object.assign({}, x), { source: { alias: 'basetbl' } }))
                        : [
                            Object.assign(Object.assign({}, select.columns[0]), { direction: 'ASC' }),
                        ],
                },
            ],
        };
        const res = {
            commandType: 'select',
            selectAll: true,
            from: {
                subQuery: innerSelect,
                alias: '_RowNumberResult',
            },
            where: {
                conditionType: 'between',
                expr: {
                    exprType: 'column',
                    columnName: '_RowNumber',
                    source: {
                        alias: '_RowNumberResult',
                    },
                },
                left: {
                    exprType: 'value',
                    value: offset + 1,
                },
                right: {
                    exprType: 'value',
                    value: offset + count,
                },
            },
        };
        return res;
    }
    getPageQuery(offset, count) {
        if (!this.driver)
            return null;
        let select = this.createSelect();
        if (!select)
            return null;
        if (this.dialect.rangeSelect)
            select.range = { offset: offset, limit: count };
        else if (this.dialect.rowNumberOverPaging && (offset > 0 || !this.dialect.topRecords))
            select = this.getRowNumberOverSelect(select, offset, count);
        else if (this.dialect.limitSelect)
            select.topRecords = count;
        return select;
        // const sql = treeToSql(this.driver, select, dumpSqlSelect);
        // return sql;
    }
    getExportQuery(postprocessSelect = null) {
        const select = this.createSelect({ isExport: true });
        if (!select)
            return null;
        if (postprocessSelect)
            postprocessSelect(select);
        const sql = (0, dbgate_sqltree_1.treeToSql)(this.driver, select, dbgate_sqltree_1.dumpSqlSelect);
        return sql;
    }
    getExportQueryJson(postprocessSelect = null) {
        const select = this.createSelect({ isExport: true });
        if (!select)
            return null;
        if (postprocessSelect)
            postprocessSelect(select);
        return select;
    }
    getExportColumnMap() {
        var _a, _b;
        const changesDefined = ((_a = this.config.hiddenColumns) === null || _a === void 0 ? void 0 : _a.length) > 0 || ((_b = this.config.addedColumns) === null || _b === void 0 ? void 0 : _b.length) > 0;
        if (this.isDynamicStructure && !changesDefined) {
            return null;
        }
        return this.getColumns(null)
            .filter(col => col.isChecked)
            .map(col => ({
            dst: col.uniqueName,
            src: col.uniqueName,
            ignore: !changesDefined,
        }));
    }
    resizeColumn(uniqueName, computedSize, diff) {
        this.setConfig(cfg => {
            const columnWidths = Object.assign({}, cfg.columnWidths);
            if (columnWidths[uniqueName]) {
                columnWidths[uniqueName] += diff;
            }
            else {
                columnWidths[uniqueName] = computedSize + diff;
            }
            return Object.assign(Object.assign({}, cfg), { columnWidths });
        });
    }
    getCountQuery() {
        let select = this.createSelect();
        select.orderBy = null;
        if (this.isGrouped) {
            select = {
                commandType: 'select',
                from: {
                    subQuery: select,
                    alias: 'subq',
                },
                columns: [
                    {
                        exprType: 'raw',
                        sql: 'COUNT(*)',
                        alias: 'count',
                    },
                ],
            };
        }
        else {
            select.columns = [
                {
                    exprType: 'raw',
                    sql: 'COUNT(*)',
                    alias: 'count',
                },
            ];
            select.selectAll = false;
        }
        return select;
        // const sql = treeToSql(this.driver, select, dumpSqlSelect);
        // return sql;
    }
    compileJslFilters() {
        var _a, _b, _c;
        const filters = this.config && this.config.filters;
        if (!filters)
            return null;
        const conditions = [];
        for (const name in filters) {
            const column = this.isDynamicStructure ? null : this.columns.find(x => x.columnName == name);
            if (!this.isDynamicStructure && !column)
                continue;
            const filterBehaviour = (_c = (_a = this.filterBehaviourOverride) !== null && _a !== void 0 ? _a : (_b = this.driver) === null || _b === void 0 ? void 0 : _b.getFilterBehaviour(column.dataType, dbgate_tools_2.standardFilterBehaviours)) !== null && _c !== void 0 ? _c : (0, dbgate_tools_2.detectSqlFilterBehaviour)(column.dataType);
            try {
                const condition = (0, dbgate_filterparser_1.parseFilter)(filters[name], filterBehaviour);
                const replaced = lodash_1.default.cloneDeepWith(condition, (expr) => {
                    if (expr.exprType == 'placeholder')
                        return {
                            exprType: 'column',
                            columnName: this.isDynamicStructure ? name : column.columnName,
                        };
                });
                conditions.push(replaced);
            }
            catch (err) {
                // filter parse error - ignore filter
            }
        }
        if (this.config.multiColumnFilter) {
            const placeholderCondition = (0, dbgate_filterparser_1.parseFilter)(this.config.multiColumnFilter, dbgate_tools_2.stringFilterBehaviour);
            if (placeholderCondition) {
                conditions.push({
                    conditionType: 'anyColumnPass',
                    placeholderCondition,
                });
            }
        }
        if (conditions.length == 0)
            return null;
        return {
            conditionType: 'and',
            conditions,
        };
    }
    switchToFormView(rowIndex) {
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { isFormView: true, formViewRecordNumber: rowIndex })));
    }
    switchToJsonView() {
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { isJsonView: true })));
    }
    formViewNavigate(command, allRowCount) {
        switch (command) {
            case 'begin':
                this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { formViewRecordNumber: 0 })));
                break;
            case 'previous':
                this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { formViewRecordNumber: Math.max((cfg.formViewRecordNumber || 0) - 1, 0) })));
                break;
            case 'next':
                this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { formViewRecordNumber: Math.max((cfg.formViewRecordNumber || 0) + 1, 0) })));
                break;
            case 'end':
                this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { formViewRecordNumber: Math.max(allRowCount - 1, 0) })));
                break;
        }
        this.reload();
    }
}
exports.GridDisplay = GridDisplay;
function reloadDataCacheFunc(cache) {
    return Object.assign(Object.assign({}, (0, GridConfig_1.createGridCache)()), { refreshTime: new Date().getTime() });
}
exports.reloadDataCacheFunc = reloadDataCacheFunc;
